import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { updateGroupTrip } from "../../api/trip";
// import DatePicker from "react-multi-date-picker";
import { InputCreateProject } from "../project/createProjectPop";
import DatePicker from "../project/datePicker";
import moment from "jalali-moment";
import ClockArea from "../areaManager/createAreaPop.jsx/clockArea";

export default function LevelOnePop({
  level,
  setLevel,
  tripName,
  setTripName,
  date,
  setDate,
  clockTrip,
  setClockTrip,
  setClockTripEnd,
  countTrip,
  setCountTrip,
  dataSelected,
  dataDef,
}) {
  const [showDatePicker, setShowDatePicker] = useState();

  const [showClock, setShowClock] = useState();
  const [clockTime, setClockTime] = useState();
  const [clockTimeEnd, setClockTimeEnd] = useState();

  // console.log(date);

  useEffect(() => {
    if (dataDef) {
      setClockTime(dataDef?.startAt?.split("-", 2)[1]);
    }
  }, [clockTime]);
  useEffect(() => {
    if (dataDef?.endAt) {
      setClockTimeEnd(dataDef?.endAt?.split("-", 2)[1]);
    }
  }, [dataDef]);

  return (
    <>
      <DatePicker
        sx={{ marginLeft: "-30px !important" }}
        date={date}
        setDate={setDate}
        show={showDatePicker}
        setShow={setShowDatePicker}
      />
      <ClockArea
        date={clockTime}
        setDate={setClockTime}
        dateEnd={clockTimeEnd}
        setDateEnd={setClockTimeEnd}
        show={showClock}
        setShow={setShowClock}
      />
      <Box
        mt="20px"
        gap="10px"
        display="flex"
        flexWrap={"wrap"}
        justifyContent="space-between"
      >
        <InputCreateProject
          placeholder={"نام اردو را وارد کنید."}
          label="نام اردو"
          value={tripName}
          onChange={(e) => setTripName(e.target.value)}
        />
        <InputCreateProject
          onClick={(e) => {
            setShowDatePicker(e.currentTarget);
          }}
          value={
            date?.length >= 2
              ? `${date[0].year}/${date[0].month}/${date[0].day} تا ${date[1].year}/${date[1].month}/${date[1].day} `
              : date?.length >= 1
              ? `${date[0].day}/${date[0].month}/${date[0].year}`
              : //   : defData
                //   ? `${defData?.startAt.split(" ", 1)} - ${defData?.endAt.split(
                //       " ",
                //       1
                //     )}`
                ""
          }
          placeholder={"زمان شروع و پایان اردو را انتخاب کنید."}
          label="بازه زمانی اردو"
        />
        <InputCreateProject
          placeholder={"زمان شروع و پایان پروژه را انتخاب کنید."}
          label="ساعت شروع و پایان"
          value={
            clockTime
              ? clockTime + " " + "تا" + " " + clockTimeEnd
              : dataDef?.endAt
              ? `${dataDef?.startAt?.split("-", 2)[1]} تا ${
                  dataDef?.endAt?.split("-", 2)[1]
                }`
              : ""
          }
          onClick={(e) => {
            setShowClock(e.currentTarget);
          }}
        />
        {/* {!dataDef && ( */}
          <InputCreateProject
            onChange={(e) => setCountTrip(e.target.value)}
            value={countTrip}
            type="number"
            placeholder={"تعداد منطقه را وارد کنید."}
            label="تعداد منطقه"
          />
        {/* )} */}

        <button
          onClick={() => {
            if (date?.length >= 2 && countTrip && tripName) {
              if (!dataDef) {
                updateGroupTrip(dataSelected, {
                  name: tripName,
                  startAt: date[0]?.toUnix() * 1000,
                  endAt: date[1]?.toUnix() * 1000,
                  dailyStartAt: clockTime,
                  dailyEndAt: clockTimeEnd,
                })
                  .then(() => setLevel(2))
                  .catch(() => {});
              } else {
                const timestamp = moment
                  .from(
                    `${date[0].year}/${date[0].month}/${date[0].day}`,
                    "fa",
                    "YYYY/MM/DD"
                  )
                  .valueOf();
                const timestampEnd = moment
                  .from(
                    `${date[1].year}/${date[1].month}/${date[1].day}`,
                    "fa",
                    "YYYY/MM/DD"
                  )
                  .valueOf();
                updateGroupTrip(dataDef.id, {
                  name: tripName,
                  startAt: timestamp,
                  endAt: timestampEnd,
                  dailyStartAt: clockTime,
                  dailyEndAt: clockTimeEnd,
                })
                  .then(() => setLevel(2))
                  .catch(() => {});
              }
            }
            // setLevel(2)
          }}
          style={
            date?.length >= 2 && countTrip && tripName
              ? {}
              : { opacity: "0.5", cursor: "no-drop" }
          }
          className="btnCreate"
        >
          {"مرحله بعدی"}
        </button>
      </Box>
    </>
  );
}
